import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FaCloud } from "react-icons/fa";

const footerItems = [

]

export default function Footer() {
  const location = useLocation();
  const handleLinkClick = (event, id) => {
    event.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="w-full bg-gray-900">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/*Grid*/}
        <div className="py-16 flex justify-between items-center flex-col gap-8 lg:flex-row">
          <div className="text-white flex items-center gap-2">
            CROSS Intelligence
          </div>
          <ul className="text-lg text-center sm:flex items-center justify-center gap-14 lg:gap-10 xl:gap-14 transition-all duration-500">
            {footerItems.map((item, index) => (
              <li key={index} className="sm:my-0 my-2">
                <a
                  href={item.to}
                  className={`hover:text-gray-400 ${location.hash === item.to ? 'text-white' : 'text-gray-400'}`}
                  onClick={(event) => handleLinkClick(event, item.to.substring(1))}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="flex space-x-4 sm:justify-center">
            <a
              href="https://linkedin.com/in/jananichandran"
              className="w-9 h-9 rounded-full bg-gray-800 flex justify-center items-center hover:bg-indigo-600"
            >
              <svg
                className="w-[1rem] h-[1rem] text-white"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.8794 11.5527V3.86835H0.318893V11.5527H2.87967H2.8794ZM1.59968 2.81936C2.4924 2.81936 3.04817 2.2293 3.04817 1.49188C3.03146 0.737661 2.4924 0.164062 1.61666 0.164062C0.74032 0.164062 0.167969 0.737661 0.167969 1.49181C0.167969 2.22923 0.723543 2.8193 1.5829 2.8193H1.59948L1.59968 2.81936ZM4.29668 11.5527H6.85698V7.26187C6.85698 7.03251 6.87369 6.80255 6.94134 6.63873C7.12635 6.17968 7.54764 5.70449 8.25514 5.70449C9.18141 5.70449 9.55217 6.4091 9.55217 7.44222V11.5527H12.1124V7.14672C12.1124 4.78652 10.8494 3.68819 9.16483 3.68819C7.78372 3.68819 7.17715 4.45822 6.84014 4.98267H6.85718V3.86862H4.29681C4.33023 4.5895 4.29661 11.553 4.29661 11.553L4.29668 11.5527Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        </div>
        {/*Grid*/}
        <div className="py-7 border-t border-gray-700">
          <div className="flex items-center justify-center">
            <span className="text-gray-400 ">
              All rights reserved © 2024 CROSS Intelligence
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}